'use client';

/**
 * SyncProvider (seja 219, A4): ob prijavi sproži sinhronizacijo localStorage ⇄ baza.
 *
 * - initSync() preveri /api/zadeve (auth), enkrat migrira lokalne zadeve, hidrira
 *   seznam + canvas in naloži detajl aktivne zadeve. Če user ni prijavljen, tiho
 *   miruje → app deluje samo na localStorage (additivno).
 * - Stranski-učinek komponenta: ne izrisuje ničesar.
 */
import { useEffect, useRef } from 'react';
import { useSession } from 'next-auth/react';
import { initSync } from '@/lib/stores/sync';

export function SyncProvider() {
  const { status } = useSession();
  const started = useRef(false);

  useEffect(() => {
    if (status !== 'authenticated' || started.current) return;
    started.current = true;
    void initSync();
  }, [status]);

  return null;
}
